<template>
  <Editor
    v-model="store.sectorForm.content"
    :api-key="apiKey"
    :init="{
      height: 600,
      menubar: true,
      toolbar_mode: 'sliding',
      plugins: [
        'print',
        'preview',
        'paste',
        'importcss',
        'searchreplace',
        'autolink',
        'autosave',
        'save',
        'directionality',
        'code',
        'visualblocks',
        'visualchars',
        'fullscreen',
        'image',
        'link',
        'media',
        'template',
        'codesample',
        'table',
        'charmap',
        'hr',
        'pagebreak',
        'nonbreaking',
        'anchor',
        'toc',
        'insertdatetime',
        'advlist',
        'lists',
        'wordcount',
        'imagetools',
        'textpattern',
        'noneditable',
        'help',
        'charmap',
        'quickbars',
        'emoticons',
      ],
      toolbar:
        'undo redo | blocks | formatselect fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media table | removeformat code preview fullscreen | help',
      content_style: 'body { font-family:Inter, sans-serif; font-size:14px }',
      font_size_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
      font_family_formats:
        'Arial=arial,helvetica,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Tahoma=tahoma,arial; Times New Roman=times new roman,times; Verdana=verdana,geneva;',
      automatic_uploads: true,
      image_title: false,
      file_picker_types: 'image',
      file_picker_callback: filePickerCallback,
    }"
  />
</template>

<script setup>
import { ref, watch } from 'vue'
import Editor from '@tinymce/tinymce-vue'
import { dataExtinguisher } from '@/modules/extinguisher/store'

// const props = defineProps({
//   modelValue: {
//     type: String,
//     default: "",
//   },
// });

// const emit = defineEmits(["update:modelValue"]);
// const model = ref(props.modelValue);
const store = ref(dataExtinguisher.state)
const content = ref(store.value.sectorForm.content)
// Atualiza o v-model externo
watch(
  content.value,
  (newValue) => {
    content.value = newValue
  },
  { immediate: true }
)

// Atualiza interno se valor externo mudar
// watch(
//   () => props.modelValue,
//   (newVal) => {
//     if (newVal !== model.value) {
//       model.value = newVal;
//     }
//   }
// );

const apiKey = process.env.VUE_APP_TINYMCE

const filePickerCallback = (callback, value, meta) => {
  if (meta.filetype === 'image') {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')

    input.onchange = function () {
      const file = this.files[0]
      const reader = new FileReader()

      reader.onload = function () {
        const id = 'blobid' + new Date().getTime()
        const blobCache = window.tinymce.activeEditor.editorUpload.blobCache
        const base64 = reader.result.split(',')[1]
        const blobInfo = blobCache.create(id, file, base64)
        blobCache.add(blobInfo)

        callback(blobInfo.blobUri(), { title: file.name })
      }

      reader.readAsDataURL(file)
    }

    input.click()
  }
}
</script>
